import cn from 'classnames';
import { IoClose } from 'react-icons/io5';
import ReactModal from 'react-modal';

import GuestView from '../GuestView/GuestView';

import styles from './GuestDetailsModal.module.scss';

export default function GuestDetailsModal({ isOpen, setIsOpen }) {
  return (
    <ReactModal
      className={styles.content}
      overlayClassName={styles.overlay}
      portalClassName={styles.modal}
      isOpen={isOpen}
      onRequestClose={setIsOpen}
      contentLabel="Αλλαγή στοιχείων"
      ariaHideApp={false}
    >
      <div className={cn(styles.header, styles.headerClass)}>
        <div>
          <h3 className={styles.modalHeader} key={1}>
            Αλλαγή Στοιχείων
          </h3>
        </div>
        <button type="button" className={styles.close} onClick={() => setIsOpen(false)}>
          <IoClose className={styles.closeSymbol} />
        </button>
      </div>

      <div className={cn([styles.body, 'fullBody'])}>
        <div className={styles.container}>
          <GuestView onSubmit={setIsOpen} />
        </div>
      </div>

      <div className={styles.footer} />
    </ReactModal>
  );
}
